import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchEmegencyBroadcasts(payload) {
  return { type: actionTypes.FETCH_EMERGENCY_BROADCASTS, payload };
}
export function fetchEmegencyBroadcastsSuccess(payload) {
  const byId = keyBy(payload, (data) => data.emergencybroadcastUid);
  return { type: actionTypes.FETCH_EMERGENCY_BROADCASTS_SUCCESS, payload: { byId } };
}
export function saveEmegencyBroadcast(payload) {
  return { type: actionTypes.SAVE_EMERGENCY_BROADCAST, payload };
}
export function saveEmegencyBroadcastSuccess(payload) {
  console.log('savepayload..', payload)
  return { type: actionTypes.SAVE_EMERGENCY_BROADCAST_SUCCESS, payload };
}
export function updateEmegencyBroadcast(payload) {
  return { type: actionTypes.UPDATE_EMERGENCY_BROADCAST, payload };
}
export function updateEmegencyBroadcastSuccess(payload) {
  console.log('savepayload..', payload)
  return { type: actionTypes.UPDATE_EMERGENCY_BROADCAST_SUCCESS, payload };
}